import { BudgetAdjustmentBase } from './base/budget-adjustment-base';

export class BudgetAdjustment extends BudgetAdjustmentBase { }